(function () {
  if (window.SFGProductDiscovery && typeof window.SFGProductDiscovery.refresh === 'function') {
    window.SFGProductDiscovery.refresh();
    return;
  }

  function sectionFor(element) {
    return element && element.closest ? element.closest('.shopify-section') : null;
  }

  function relatedSection() {
    var recommendations = document.querySelector('product-recommendations');
    return sectionFor(recommendations) || sectionFor(document.querySelector('.related-products'));
  }

  function reviewSection() {
    return sectionFor(document.getElementById('judgeme_product_reviews'));
  }

  function syncCardWishlist(button) {
    var saved = button.getAttribute('data-added') === 'true';
    var title = button.dataset.productTitle || 'this product';
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      (saved ? 'Remove ' : 'Save ') + title + (saved ? ' from wishlist' : ' to wishlist')
    );
  }

  function bindCardWishlists() {
    document.querySelectorAll('.sfg-card-wishlist[data-wishlist]').forEach(function (button) {
      syncCardWishlist(button);
      if (button.dataset.sfgWishlistBound === 'true') return;

      button.dataset.sfgWishlistBound = 'true';
      new MutationObserver(function () {
        syncCardWishlist(button);
      }).observe(button, {
        attributes: true,
        attributeFilter: ['data-added', 'class']
      });
    });
  }

  function bindShare(share) {
    var button = share && share.querySelector('[data-sfg-native-share]');
    if (!button || button.dataset.sfgShareBound === 'true') return;

    button.dataset.sfgShareBound = 'true';
    button.addEventListener('click', async function () {
      var title = share.dataset.shareTitle || document.title;
      var url = share.dataset.shareUrl || window.location.href;
      var status = share.querySelector('[data-sfg-share-status]');

      try {
        if (navigator.share) {
          await navigator.share({ title: title, text: 'Take a look at ' + title, url: url });
          if (status) status.textContent = 'Share menu opened.';
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          if (status) status.textContent = 'Product link copied.';
          button.querySelector('span').textContent = 'Link copied';
          window.setTimeout(function () {
            button.querySelector('span').textContent = 'Share';
          }, 1800);
        } else {
          window.prompt('Copy this product link:', url);
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (status) status.textContent = 'Sharing was not available. Please copy the page address.';
      }
    });
  }

  function arrangeDiscovery() {
    var stage = document.querySelector('[data-sfg-product-discovery-stage]');
    var links = document.querySelector('[data-sfg-product-discovery-links]');
    var share = document.querySelector('[data-sfg-product-share]');
    var related = relatedSection();

    if (!stage || !links || !share || !related || !related.parentElement) {
      bindCardWishlists();
      return;
    }

    var parent = related.parentElement;
    var reviews = reviewSection();

    if (reviews && reviews !== related && reviews.parentElement === parent && reviews.nextElementSibling !== links) {
      parent.insertBefore(reviews, related);
    }

    if (links.parentElement !== parent || links.nextElementSibling !== related) {
      parent.insertBefore(links, related);
    }

    if (share.parentElement !== parent || related.nextElementSibling !== share) {
      related.insertAdjacentElement('afterend', share);
    }

    var heading = related.querySelector('.related-products__heading, h2.title, h2');
    if (heading && heading.textContent.trim() !== 'You May Also Adore') {
      heading.textContent = 'You May Also Adore';
    }

    bindShare(share);
    bindCardWishlists();
  }

  var refreshQueued = false;

  function refresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function () {
      refreshQueued = false;
      arrangeDiscovery();
    });
  }

  window.SFGProductDiscovery = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);

  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  [300, 1000, 2500].forEach(function (delay) {
    window.setTimeout(refresh, delay);
  });
})();
